import React from 'react';
import JsBarcode from 'jsbarcode';

const PrintBarcodes = ({ selectedAssets, assetsData, handleToast }) => {
  const handlePrintBarcodes = () => {
    const selectedData = assetsData.filter((asset) =>
      selectedAssets.includes(asset.id)
    );

    if (selectedData.length === 0) {
      handleToast({
        type: "ERROR",
        message: "Please select assets first to print barcodes",
      });
      return;
    }

    // Filter assets that have barcodes
    const assetsWithBarcodes = selectedData.filter(asset => asset.barcode && asset.barcode.trim());
    
    if (assetsWithBarcodes.length === 0) {
      handleToast({
        type: "ERROR",
        message: "Selected assets don't have barcodes to print",
      });
      return;
    }

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
      
          <style>
            @media print {
              body { margin: 0; padding: 20px; }
              .barcode-container { page-break-inside: avoid; margin-bottom: 20px; }
            }
            body { font-family: Arial, sans-serif; }
            .barcode-container { 
              display: inline-block; 
              margin: 10px; 
              padding: 10px; 
              border: 1px solid #ddd; 
              text-align: center;
            }
            .asset-name { font-weight: bold; margin-bottom: 5px; }
            canvas { margin: 5px 0; }
          </style>
          <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
        </head>
        <body>
          ${assetsWithBarcodes
            .map(
              (asset) => `
            <div class="barcode-container">
              <div class="asset-name">${asset.name}</div>
              <canvas id="barcode-${asset.id}"></canvas>
            </div>
          `
            )
            .join("")}
          <script>
            ${assetsWithBarcodes
              .map(
                (asset) => `
              JsBarcode("#barcode-${asset.id}", "${asset.barcode}", {
                format: "CODE128",
                width: 2,
                height: 50,
                displayValue: true,
              });
            `
              )
              .join("")}
            window.onload = function() {
              setTimeout(() => {
                window.print();
                window.close();
              }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  return { handlePrintBarcodes };
};

export default PrintBarcodes;